import { DateFormats, type DateFormat } from "./constants";
import dayjs from "./setup";
/**
 * Formats a date into a string
 */
export function formatDate(
  date?: dayjs.ConfigType,
  format: DateFormat = DateFormats.UI_DATE_SHORT,
): string {
  if (!date) return "";
  const d = dayjs(date);
  return d.isValid() ? d.format(format) : "";
}
